import { useMemo } from "react";
import { Badge } from "@mantine/core";
import { PortalNotificationPreference } from "../../../services/admin/portalAccess.service";

const PREFERENCE_PRESENTATION: Record<
  PortalNotificationPreference,
  { label: string; color: string }
> = {
  per_report: { label: "Every report", color: "gray" },
  daily_digest: { label: "Daily summary", color: "blue" },
  both: { label: "Both", color: "indigo" },
};

interface PortalNotificationPreferenceBadgeProps {
  preference: PortalNotificationPreference;
}

export function PortalNotificationPreferenceBadge({
  preference,
}: PortalNotificationPreferenceBadgeProps) {
  const presentation = useMemo(
    () => PREFERENCE_PRESENTATION[preference],
    [preference]
  );

  return (
    <Badge
      color={presentation.color}
      variant="light"
      size="sm"
      styles={{
        root: { overflow: "visible" },
        label: { overflow: "visible", textOverflow: "clip" },
      }}
    >
      {presentation.label}
    </Badge>
  );
}
